import React, { Component } from 'react';
import ModalStepBase from '../../ModalStepBase';
import FormConfigSimulado from './FormConfigSimulado';
import CheckboxTree from 'react-checkbox-tree';
import ModalConfirm from '../../ModalConfirm';
import Loading from '../../Loading';
import Alert from 'react-s-alert';

class ModalAgendar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showModalConfirmarForcar: false,
            idPractice: 0,
            forcarReagendamento: false,
            loading: false,
            loadingFinalizar: false,
        };

        this.onAgendarFinalizar = this.onAgendarFinalizar.bind(this);
        this.onConfirmarReagendamento = this.onConfirmarReagendamento.bind(this);
        this.onClickConfirmarForcar = this.onClickConfirmarForcar.bind(this);
        this.onClickFecharModalForcar = this.onClickFecharModalForcar.bind(this);
        // this.onEditarFinalizar = this.onEditarFinalizar.bind(this);
        this.onCheckTree = this.onCheckTree.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    async handleInputChange(forcarReagendar) {
        this.setState({ loading: true })

        // console.log('handleInputChange ', event.target.name)
        // console.log('treeViewAlunos.checked',this.props.practiceTestContainer.state.treeViewAlunos.checked);
        if (forcarReagendar) {
            await this.props.practiceTestContainer.setAction('forcarreagendar')
        } else {
            await this.props.practiceTestContainer.setAction('reagendar')
        }
        this.setState({ forcarReagendamento: forcarReagendar });

        await this.props.practiceTestContainer.getPracticeConfig(false);

        this.setState({ loading: false })
    }

    async isValidStartDate(start) {
        let validStartDate = false;
        let currentDate = await this.props.practiceTestContainer.getCurrentDateHour();

       if(currentDate.getFullYear() === start.getFullYear()){
          // console.log('dta inicio valida')
        validStartDate = true;
       }
       return validStartDate;

    }

    async isValidEndDate(end) {
        let validEndDate = false;
        let currentDate = await this.props.practiceTestContainer.getCurrentDateHour();

       if(end > currentDate){
          // console.log('dta inicio valida')
        validEndDate = true;
       }
       return validEndDate;

    }

    isDateInValidPeriod(start, end) {
        let validDate = false;
        const periodSchoolGradeSelected = this.props.practiceTestContainer.state.selectedPeriodSchoolGrade;
        const periodsScheduled = this.props.practiceTestContainer.state.periodos;
        const periodchoosen = periodsScheduled.find((period) => {
            return period.idPeriodSchoolGrade === periodSchoolGradeSelected;
        })


        if ((periodchoosen.rawStartPeriod > start) || (periodchoosen.rawEndPeriod < end)) {
            console.log('Verificar que as datas estejan dentro das datas do periodo')
            //return validDate;
        } else {
            validDate = true;
            //  return validDate;
        }

        return validDate;
    }

    actionStates(action) {
        return {isAgendar: action === 'agendar',
                isForcarAgendar: action === 'forcarreagendar',
                isEditar: action === 'editar',
                isReagendar: action === 'reagendar'}
    }

    onConfirmarReagendamento() {
        this.setState({ loadingFinalizar: true })
        const {isAgendar, isForcarAgendar, isEditar, isReagendar} = this.actionStates(this.props.practiceTestContainer.state.action)
        if(isForcarAgendar) {
            let account_checked = this.props.practiceTestContainer.state.treeViewAlunos.checked.filter(el => el.startsWith("u_"));
            account_checked = account_checked.map(el => el.substr(2));

            if (account_checked.length > 1) {
                Alert.info('Selecione só um aluno!')
                this.setState({ loadingFinalizar: false })
                return;
            }

            this.setState({ showModalConfirmarForcar: true })
        }
        else if (isAgendar || isEditar || isReagendar) {
            this.onAgendarFinalizar();
        }
    }

    async onClickConfirmarForcar() {
        this.setState({ showModalConfirmarForcar: false });
        this.onAgendarFinalizar();
    }

    onClickFecharModalForcar() {
        this.setState({ showModalConfirmarForcar: false, loadingFinalizar: false });
    }

    async onAgendarFinalizar() {
        //  console.log('my action is ', this.props.practiceTestContainer.state.action)

        this.setState({ loadingFinalizar: true })

        /**
         * EDITAR REAGENDAMENTO
         * acao = editar
         * Selected Agenda with idAccountType = 1 (student)
         */


        let agendamentoSelecionado = this.props.practiceTestContainer.state.currentAgandamento;

        // console.log('agendamentoSelecionado ',agendamentoSelecionado)
        const {isAgendar, isForcarAgendar, isEditar, isReagendar} = this.actionStates(this.props.practiceTestContainer.state.action)

        /**
         * validate initial date
         */

        if (!isEditar) {
            let validStartDate = await this.isValidStartDate(this.props.practiceTestContainer.state.simulado.dtStartEvent);
            if (!validStartDate) {
                Alert.info('Informe uma data de início que esteja no ano corrente')
                this.setState({ loadingFinalizar: false })
                return;
            }

            let validEndDate = await this.isValidEndDate(this.props.practiceTestContainer.state.simulado.dtEndEvent);
            if (!validEndDate) {
                Alert.info('Informe uma data e hora de término do simulado maior que a data corrente')
                this.setState({ loadingFinalizar: false })
                return;
            }
        }


        /**
         * Validate initial and final date are between the specified Period´s dates.
         */
        let date_checked = this.isDateInValidPeriod(this.props.practiceTestContainer.state.simulado.dtStartEvent, this.props.practiceTestContainer.state.simulado.dtEndEvent)
        if (!date_checked) {
            Alert.info('Verifique o intervalo das datas para estejam dentro do intervalo do Período selecionado.')
            this.setState({ loadingFinalizar: false })
            return;
        }



        let account_checked = [];
        if (isReagendar) {
            account_checked = this.props.practiceTestContainer.state.treeViewAlunos.checked.filter(el => el.startsWith("u_"));
            account_checked = account_checked.map(el => el.substr(2));
        }

        ///console.log('checked values ', this.props.practiceTestContainer.state.treeViewAlunos.checked)

        if (isEditar && agendamentoSelecionado.EventToClass === 0) { //Edit Reagendamento aluno
            //   console.log('editing reagendamento')
            account_checked = this.props.practiceTestContainer.state.treeViewAlunos.checked.filter(el => el.startsWith("u_"));
            // console.log(this.props.practiceTestContainer.state.treeViewAlunos.checked)
            // console.log(account_checked)
            account_checked = account_checked.map(el => el.substr(2));
        }
        if (isAgendar) {
            account_checked = this.props.practiceTestContainer.state.treeViewAlunos.checked.filter(el => el.startsWith("t_"));
            // console.log(this.props.practiceTestContainer.state.treeViewAlunos.checked)
            // console.log(account_checked)
            account_checked = account_checked.map(el => el.substr(2));
        }
        if (isEditar && agendamentoSelecionado.EventToClass === 1) { //Edit Agenda (turma)
            //    console.log('editing Agendamento')
            account_checked = this.props.practiceTestContainer.state.treeViewAlunos.checked.filter(el => el.startsWith("t_"));
            // console.log(this.props.practiceTestContainer.state.treeViewAlunos.checked)
            // console.log(account_checked)
            account_checked = account_checked.map(el => el.substr(2));
        }
        if (isReagendar) {

            //      console.log('REAGENDAR O QUEE ???? AGENDA O REAGENDAR REAGENDAMENTO ??? CHEECK')
            account_checked = this.props.practiceTestContainer.state.treeViewAlunos.checked.filter(el => el.startsWith("u_"));
            // console.log(this.props.practiceTestContainer.state.treeViewAlunos.checked)
            // console.log(account_checked)
            account_checked = account_checked.map(el => el.substr(2));
        }


        /**
         * FORCAR REAGENDAMENTO
         */

        if (isForcarAgendar) {
            account_checked = this.props.practiceTestContainer.state.treeViewAlunos.checked.filter(el => el.startsWith("u_"));
            account_checked = account_checked.map(el => el.substr(2));

            if (account_checked.length > 1) {
                Alert.info('Selecione só um aluno!')
                this.setState({ loadingFinalizar: false })
                return;
            }
        }

        console.log(account_checked)
        if (account_checked.length > 0) {
            this.props.practiceTestContainer.state.simulado.arrIdAccountMembers = account_checked.join();

            /**
             * Validate dates with other simulation types
             */
            // console.log('checked types ', this.props.practiceTestContainer.state.simulado.arrIdAccountMembers)
            if (!isForcarAgendar && !isReagendar) {
                let datesValid = await this.props.practiceTestContainer.validarAgendasDaTurmaMultipleChecked();
                //  console.log('datesValid ',datesValid)
                if (!datesValid) {
                    // console.log('date is not valid')
                    Alert.info('Verifique o período selecionado para que não sobreponha com outro tipo de simulado agendado.')
                    this.setState({ loadingFinalizar: false })
                    return;
                }
            }
            var hours = Math.abs(this.props.practiceTestContainer.state.simulado.dtEndEvent - this.props.practiceTestContainer.state.simulado.dtStartEvent) / 36e5;
            // console.log('hours', hours)

            if (hours <= 0) {
                Alert.info('Informe um intervalo de datas válido para o simulado.')
                this.setState({ loadingFinalizar: false })
                return;
            }
            if (hours < 1) {
                var confirm = window.confirm("O prazo para o simulado é menor que uma hora, deseja continuar mesmo assim?");
                if (confirm === true) {
                    this.finishModal()
                } else {
                    this.setState({ loadingFinalizar: false })
                }

            } else {
                this.finishModal()
            }

        } else {
            if (isReagendar || isForcarAgendar) {
                Alert.info('Selecione pelo menos um aluno!')
            }
            if (isAgendar) {
                Alert.info('Selecione pelo menos uma turma!')
            }
            this.setState({ loadingFinalizar: false })
        }
    }

    async finishModal() {
        this.props.onCloseModal(true);
    }

    removeFromArray = (array, element) => {
        return array.filter(el => el !== element);
    }

    addToArray = (array, element) => {
        if (array.indexOf(element) === -1) array.push(element);
        return array;
    }

    onCheckTree(checked, targetNode) {
        // segmento
        if (targetNode.treeDepth === 0) {
            if (targetNode.checked) {
                targetNode.children.forEach(serie => {
                    serie.children.forEach(el => {
                        checked = this.addToArray(checked, el.value)
                    })
                })
            }
            else {
                targetNode.children.forEach(serie => {
                    serie.children.forEach(el => {
                        checked = this.removeFromArray(checked, el.value)
                    })
                })
            }
        }
        // série
        if (targetNode.treeDepth === 1) {
            if (targetNode.checked) {
                targetNode.children.forEach(el => {
                    checked = this.addToArray(checked, el.value)
                })
            }
            else {
                targetNode.children.forEach(el => {
                    checked = this.removeFromArray(checked, el.value)
                })
            }
        }
        // turma
        if (targetNode.treeDepth === 2) {
            if (targetNode.checked) {
                checked = this.addToArray(checked, targetNode.value)
            }
            else {
                checked = this.removeFromArray(checked, targetNode.value)
            }
        }
        this.props.practiceTestContainer.setState({ treeViewAlunos: { ...this.props.practiceTestContainer.state.treeViewAlunos, checked } })
    }


    render() {

        var treeViewAlunos = this.props.practiceTestContainer.state.treeViewAlunos
        console.log('treeViewAlunos',treeViewAlunos)
        const {isAgendar, isForcarAgendar, isEditar, isReagendar} = this.actionStates(this.props.practiceTestContainer.state.action)

        return (<ModalStepBase {...this.props} hideClose={this.props.loading} loadingFinalizar={this.state.loadingFinalizar} onClickFinish={this.onConfirmarReagendamento} stepsContent={[
            {
                title: "Configurar Simulado",
                content: (<FormConfigSimulado practiceContainer={this.props.practiceTestContainer} userContainer={this.props.userContainer} desabilitarInfoGeral={true} />)
            },
            {

                title: (<>
                    {(isForcarAgendar || isReagendar) && "Selecionar Alunos"}
                    {(isAgendar || isEditar) && "Selecionar Turmas"}


                </>),
                content: (<div>
                    {(isForcarAgendar || isReagendar) && <h4 className="edb-text-bold edb-margin-none">Passo 2: Selecionar Alunos</h4>}
                    {(isAgendar || isEditar) && <h4 className="edb-text-bold edb-margin-none"> Passo 2: Selecionar Turmas</h4>}
                    {/* <div className="adap-input-icon-container ">
                            <i className="adap-input-icon fas fa-search"></i>
                            <input className="adap-input" placeholder="Filtrar" />
                        </div> */}
                    {(isForcarAgendar || isReagendar) && <div className="edb-padding adap-gray">
                        <label className="edb-margin-none-bottom">
                            <input type="radio" name="filtro-selecao-alunos"
                                value='1'
                                checked={isReagendar}
                                onChange={() => this.handleInputChange(false) } />
                            &nbsp;
                            Exibir alunos que não realizaram o simulado
                        </label>
                        <label className="edb-margin-none-bottom">
                            <input type="radio" name="filtro-selecao-alunos"
                                value='2'
                                checked={isForcarAgendar}
                                onChange={() => this.handleInputChange(true) } />
                            &nbsp;
                            Alunos que já realizaram simulado (caso seja necessário forçar o reagendamento)
                        </label>
                    </div>}
                    {false && isReagendar && <label className="edb-margin-small-top">
                        <span>Exibindo somente alunos que não realizaram o simulado e não possuem nenhum reagendamento</span>
                    </label>}
                    {isForcarAgendar && treeViewAlunos.nodes.length === 0 && <label className="edb-margin-small-top">
                        <span>Não há alunos ainda em situação para forçar o reagendamento</span>
                    </label>}
                    {(isAgendar || isReagendar || isForcarAgendar) &&
                        <div className="edb-margin-top edb-margin-bottom">
                            {this.state.loading && <Loading />}
                            {!this.state.loading && <CheckboxTree
                                nodes={treeViewAlunos.nodes}
                                checked={treeViewAlunos.checked}
                                expanded={treeViewAlunos.expanded}
                                onCheck={this.onCheckTree}
                                onExpand={expanded => this.props.practiceTestContainer.setState({ treeViewAlunos: { ...treeViewAlunos, expanded } })}

                                icons={{
                                    check: <i className="far fa-check-square" ></i>,
                                    uncheck: <i className="far fa-square" ></i>,
                                    halfCheck: <i className="far fa-minus-square" ></i>,
                                    expandClose: <i className="fas fa-chevron-down"></i>,
                                    expandOpen: <i className="fas fa-chevron-up"></i>,
                                    parentClose: <div style={{ width: 0 }}></div>,
                                    parentOpen: <div style={{ width: 0 }}></div>,
                                    leaf: <div style={{ width: 0 }}></div>
                                }}
                            />}
                        </div>}
                    {isEditar &&
                        <div className="edb-margin-top edb-margin-bottom edb-disabled">
                            {this.state.loading && <Loading />}
                            {!this.state.loading && <CheckboxTree
                                nodes={treeViewAlunos.nodes}
                                checked={treeViewAlunos.checked}
                                expanded={treeViewAlunos.expanded}
                                onCheck={this.onCheckTree}
                                onExpand={expanded => this.props.practiceTestContainer.setState({ treeViewAlunos: { ...treeViewAlunos, expanded } })}
                                icons={{
                                    check: <i className="far fa-check-square" ></i>,
                                    uncheck: <i className="far fa-square" ></i>,
                                    halfCheck: <i className="far fa-minus-square" ></i>,
                                    expandClose: <i className="fas fa-chevron-down"></i>,
                                    expandOpen: <i className="fas fa-chevron-up"></i>,
                                    parentClose: <div style={{ width: 0 }}></div>,
                                    parentOpen: <div style={{ width: 0 }}></div>,
                                    leaf: <div style={{ width: 0 }}></div>
                                }}
                            />}
                        </div>}
                    {false && (isReagendar || isForcarAgendar) && <label className="edb-margin-small-top">
                        <input type="checkbox" name="forcarreagendar" checked={this.state.forcarReagendamento} onChange={this.handleInputChange} />
                        <span>Forçar Reagendamento</span>
                    </label>}

                    {this.state.showModalConfirmarForcar && <ModalConfirm isOpen={this.state.showModalConfirmarForcar}
                        title="Confirma o reagendamento forçado?"
                        content='Você selecionou um aluno que já realizou este simulado. Ao selecionar "Sim", você estará forçando o agendamento de um novo simulado. O resultado anterior será excluído e uma nova data marcada para esse aluno.'

                        confirmText="Sim"
                        confirmLoadingText="Forçando agendamento, por favor aguarde..."
                        onClickConfirm={this.onClickConfirmarForcar}
                        loadingConfirm={this.state.loadingExcluir}

                        cancelText="Não"
                        onClickCancel={this.onClickFecharModalForcar}
                    />}

                </div>)
            }
        ]} />
        );
    }
}

export default ModalAgendar;
